import EDC from '@/components/games/shared/globals';
import Selector from './selector';
import store from '@/store/index';
import router from '@/router';
import CursorManager from '@/components/games/shared/cursor-manager';
import Button from '@/components/games/shared/button';
/**
 *
 */
EDC.Games.GenderSelect.Scenes.Main = function () {};
/**
 *
 */
EDC.Games.GenderSelect.Scenes.Main.prototype.init = function () {
  this.bg = null;
  this.content = null;
  this.group = null;
  this.cursorManager = null;
  this.backButton = null;
  this.scale.off('resize', this.resize, this);
};
/**
 *
 */
EDC.Games.GenderSelect.Scenes.Main.prototype.create = function () {
  this.cursorManager = new CursorManager(this.game.canvas);
  this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'background');
  this.content = this.add.container();

  const logo = this.add.sprite(0, 0, 'logo');
  logo.setScale(1.5);

  const titleFrame = this.add.sprite(0, 0, 'title-frame');
  titleFrame.setScale(1.5);
  titleFrame.setPosition(titleFrame.displayWidth / 2 + logo.displayWidth / 2,
    titleFrame.displayHeight / 2);

  const titleSpr = this.add.sprite(0, 0, 'title');
  titleSpr.setScale(1.5);
  titleSpr.setPosition(titleFrame.x, titleFrame.y);

  logo.setPosition(175, titleFrame.displayHeight / 2);
  this.content.add(titleFrame);
  this.content.add(logo);
  this.content.add(titleSpr);

  const boySelector = new Selector(
    this,
    this.content,
    {
      background: 'boy-bg',
      textNormal: 'boy-text-dark',
      textLight: 'boy-text-light',
      character: 'boy',
      signNormal: 'boy-symbol-dark',
      signLight: 'boy-symbol-light',
    },
    this.onBoySelected.bind(this),
  ).create(titleFrame.displayWidth * 0.15 + logo.displayWidth / 2, 400);

  const girlSelector = new Selector(
    this,
    this.content,
    {
      background: 'girl-bg',
      textNormal: 'girl-text-dark',
      textLight: 'girl-text-light',
      character: 'girl',
      signNormal: 'girl-symbol-dark',
      signLight: 'girl-symbol-light',
      signOffset: { x: -5, y: 0 },
    },
    this.onGirlSelected.bind(this),
  ).create(titleFrame.displayWidth * 0.58 + logo.displayWidth / 2, 400);

  const bSize = boySelector.getSize();
  const bPos = boySelector.getPosition();
  const gPos = girlSelector.getPosition();
  const x = (gPos.x - (bPos.x + bSize.width)) / 2;
  const chooseSpr = this.add.sprite(gPos.x - x, gPos.y + bSize.height * 0.45, 'choose');
  chooseSpr.setScale(1.5);
  this.content.add(chooseSpr);

  this.backButton = new Button(this, 100, 100).create('back-normal', 'back-hover');
  this.backButton.setClickCallback(this.onBackBtnClick.bind(this));

  this.g = this.add.graphics(0, 0);
  this.scale.on('resize', this.resize, this);
  this.resize({ width: this.scale.width, height: this.scale.height });
};

EDC.Games.GenderSelect.Scenes.Main.prototype.onBackBtnClick = function () {
  const url = new URL(window.location.href);
  if (url.searchParams.get('edit')) {
    router.push({ name: 'profile' });
  } else {
    this.backToGrade();
  }
};

EDC.Games.GenderSelect.Scenes.Main.prototype.backToGrade = function () {
  this.input.enabled = false;
  this.time.delayedCall(200, this.previousScene, [], this);
};

EDC.Games.GenderSelect.Scenes.Main.prototype.previousScene = function () {
  this.scene.start('mainGrade');
};
/**
 *
 */

EDC.Games.GenderSelect.Scenes.Main.prototype.resize = function (gameSize) {
  const { width } = gameSize;
  const { height } = gameSize;

  this.cameras.resize(width, height);

  const bgW = this.bg.width;
  const neededScaleX = width / bgW;
  const bgH = this.bg.height;
  const neededScaleY = height / bgH;
  let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
  this.bg.setScale(neededScale);
  this.bg.setPosition(width / 2, height / 2);

  this.content.setPosition(0, 0);
  this.content.setScale(1, 1);
  let bounds = this.content.getBounds();
  const contentWidth = bounds.width;
  const contentHeight = bounds.height;
  const scaleX = (width * 0.8) / contentWidth;
  const scaleY = (height * 0.8) / contentHeight;
  neededScale = scaleX > scaleY ? scaleY : scaleX;
  // neededScale = width > height ? scaleY : scaleX;
  this.content.setScale(neededScale);
  bounds = this.content.getBounds();
  this.content.setPosition((width - bounds.width) / 2, (height - bounds.height) / 2);

  this.backButton.setScale(1, 1);
  const backSize = this.backButton.getSize();
  const backScaleX = (width * 0.07) / backSize.width;
  const backScaleY = (height * 0.07) / backSize.height;
  neededScale = backScaleX > backScaleY ? backScaleX : backScaleY;
  this.backButton.setScale(neededScale, neededScale);
  this.backButton.setPosition(100 * neededScale, height - 100 * neededScale);
};
/**
 *
 */
EDC.Games.GenderSelect.Scenes.Main.prototype.onGirlSelected = function () {
  this.cursorManager.resetCursor();
  store.dispatch('children/updateNewProfile', { gender: 'girl' });
  this.input.enabled = false;
  this.time.delayedCall(500, this.nextScene, [], this);
};
/**
 *
 */
EDC.Games.GenderSelect.Scenes.Main.prototype.onBoySelected = function () {
  this.cursorManager.resetCursor();
  store.dispatch('children/updateNewProfile', { gender: 'boy' });
  this.input.enabled = false;
  this.time.delayedCall(500, this.nextScene, [], this);
};

EDC.Games.GenderSelect.Scenes.Main.prototype.nextScene = function () {
  this.scene.start('mainAvatar');
};

export default EDC.Games.GenderSelect.Scenes.Main;
